var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlusBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01176 15.6791V10.987H4.31905C4.05748 10.9867 3.8074 10.8826 3.62244 10.6976C3.43748 10.5126 3.33373 10.2619 3.33337 10.0002C3.33373 9.73863 3.43748 9.48786 3.62244 9.30288C3.8074 9.11789 4.05748 9.0138 4.31905 9.01345H9.01176V4.322C9.01176 4.0601 9.11584 3.80904 9.30082 3.62366C9.4858 3.43828 9.73687 3.33378 9.99874 3.33325C10.2607 3.33378 10.5117 3.43813 10.6967 3.62366C10.8817 3.80918 10.9859 4.06064 10.9857 4.32265V9.0141H15.6797C15.9413 9.01445 16.1914 9.11854 16.3763 9.30353C16.5613 9.48851 16.6664 9.73928 16.6667 10.0009C16.6664 10.2625 16.5613 10.5133 16.3763 10.6983C16.1914 10.8832 15.9413 10.9873 15.6797 10.9877H10.9857V15.6798C10.9858 15.8094 10.9598 15.9377 10.9102 16.0574C10.8606 16.1772 10.7883 16.2862 10.6967 16.3778C10.605 16.4695 10.4961 16.5421 10.3763 16.5917C10.2566 16.6413 10.1283 16.6667 9.99874 16.6666C9.86909 16.6667 9.74092 16.641 9.62113 16.5914C9.50134 16.5418 9.39247 16.4692 9.30082 16.3775C9.20918 16.2858 9.13679 16.177 9.08728 16.0571C9.03777 15.9373 9.01158 15.8088 9.01176 15.6791Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusBlack);
export default __webpack_public_path__ + "static/media/Icon-Plus-Black.765aa0e7.svg";
export { ForwardRef as ReactComponent };